//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {Fetch} from "../../utils/storage"
import   {Api} from "../../utils/api"
import {ParseTime} from "../../utils/time"
import NotFound from '../../components/NotFound'

export default {
    name: 'blank',
    components: {
        NotFound
    },
    filters: {
    },
    data () {
        return {
            OrderList:[],
            UserID:0,
            Limit:999,
            Page:1,
        }
    },
    created () {
        this.UserID = Fetch("ID")
        this.fetchOrderList()
    },
    methods : {
        ParseTime,
        async fetchOrderList() {
            let res = await Api('GetOrderList',{
                Data:{
                    UserID:this.UserID,
                    Status:'paid'
                },
                Limit:this.Limit,
                Offset: (this.Page-1) * this.Limit,
                Order:'updated_at desc',
                Preloads:[
                    {Column:'OrderInfo'},
                    {Column:'Ticket'},
                ]
            })
            this.OrderList = res.data.List || []
        },
        handleOrderTicket(id) {
            this.$router.push(`/order/ticket/detail/${id}`)
        },
        async handleOrderLive(subID) {
            try {
                let res = await Api('GetSubMeetingList',{
                    Data:{
                        ID:subID,
                    }
                })
                //修改一下这边的逻辑
                switch(res.data.List[0].LiveResourceType){
                    case 'xiaoetong':
                        window.location.href = `https://zhibo.fuyouhuiyi.com/detail/${res.data.List[0].LiveResourceID}/4`
                        break;
                    case 'xiaoetong-zhuanlan':
                        window.location.href = `https://zhibo.fuyouhuiyi.com/detail/${res.data.List[0].LiveResourceID}/6`
                        break;
                    case 'tencent':
                        window.location.href = `http://enroll.admin.fuyouhuiyi.com/#/download/notice/file`
                        break;
                    case 'zoom':
                        window.location.href = `http://enroll.admin.fuyouhuiyi.com/#/download/notice/file`
                        break;
                    case 'third-part':
                        window.location.href = `${res.data.List[0].LiveResourceID}`
                        break;
                }
            }
            catch (err) {
                this.$vux.toast.show({
                    text: '获取直播地址错误：'+err.message,
                    type: 'text',
                    width: '3rem'
                })

            }
        },
        parseMeetingTime(str) {
            let timeArr = str.split('----')
            if (timeArr.length !== 2) {
                return ''
            }
            let start = ParseTime(timeArr[0],'{y}-{m}-{d}')
            let end = ParseTime(timeArr[1],'{y}-{m}-{d}')
            return `${start} 至 ${end}`
        }
    }
}
